/** Keep uncertain commands across retries/reloads; never silently mint another key. */
export type InventoryIntent<T = unknown> = { key: string; payload: T; endpoint?: string };
const slot = 'opstrack.inventory.pending.v1';
const ownerSlot = 'opstrack.inventory.owner.v1';
const listeners = new Set<() => void>();
const notify = () => { for (const listener of listeners) listener(); };
export function subscribeInventoryIntent(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export const intentEndpoint = (intent: InventoryIntent) => intent.endpoint ?? '/api/v1/stock/movement/';
const ownedSlot = (storage: Pick<Storage, 'getItem'>) => `${slot}:${storage.getItem(ownerSlot) ?? 'unresolved'}`;
export function setInventoryOwner(storage: Pick<Storage, 'setItem'>, userId: number) { storage.setItem(ownerSlot, String(userId)); notify(); }
export function loadIntent(storage: Pick<Storage, 'getItem'>): InventoryIntent | null {
  const value = storage.getItem(ownedSlot(storage));
  if (!value) return null;
  try {
    const parsed = JSON.parse(value);
    return typeof parsed.key === 'string' && parsed.payload ? parsed : null;
  } catch { return null; }
}
export function saveIntent<T>(storage: Pick<Storage, 'setItem' | 'getItem'>, payload: T, endpoint?: string): InventoryIntent<T> {
  const intent = { key: crypto.randomUUID(), payload, ...(endpoint ? { endpoint } : {}) };
  storage.setItem(ownedSlot(storage), JSON.stringify(intent));
  notify();
  return intent;
}
export function clearIntent(storage: Pick<Storage, 'removeItem' | 'getItem'>) { storage.removeItem(ownedSlot(storage)); notify(); }

export function isInventoryMutation(url: string, method: string) {
  const path = new URL(url, 'http://local.invalid').pathname;
  return method.toLowerCase() === 'post' && /^\/api\/(?:v1\/)?stock\/(?:$|(?:add|remove|count|transfer|merge|assign|return)\/$|tool\/(?:available\/|assigned\/)?$|\d+\/serialize\/$)/.test(path);
}
